<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card p-p-4">
            <form #facturaEditorForm="ngForm" 
                  (ngSubmit)="confirmarFacturar($event);"
                  [ngClass]="{'disabledForm': factura && factura.internalStatus && factura.internalStatus == 'POSTED'}"><!-- facturaEditorForm.reset();-->
                <div class="p-fluid p-formgrid grid">
                    <div class="p-field col-12">
                        <h2 class="uppercase">{{ appConfig.app.name }}  {{ factura.secuencial ?  '|' : '' }} {{ factura.secuencial ?  factura.secuencial : '' }}</h2>
                    </div>
                    <div class="p-field col-12 md:col-6 mb-0">
                        <div class="font-bold text-bluegray-500 bg-bluegray-100 p-2 mx-0 uppercase border-round-top">{{'Datos del Cliente'}}</div>
                        <div class="bg-bluegray-50 p-2 mx-0 border-round-bottom"   style="min-height: 91%">
                            <div class="p-field col-12"
                                 *ngIf="factura && factura.claveAcceso">
                                <i class="pi pi-key"></i><span>{{ factura.claveAcceso }}</span>
                            </div>
                            <div class="p-p-field col-12">
                                <p-button styleClass="p-button-outlined p-button-plain"
                                          (click)="activePopupSubjectCustomers($event)"
                                          [disabled]="(factura && factura.secuencial)">
                                    <ng-template pTemplate="content">
                                        <div class="p-field col-12 mb-0">
                                            <div class="flex align-items-center justify-content-between">
                                                {{(subjectCustomer && subjectCustomer.customerFullName) ? subjectCustomer.customerFullName : 'Cliente...'}}
                                                <i class="pi pi-user-edit required-icon"></i>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-button>
                            </div>
                            <div class="p-field col-12" *ngIf="subjectCustomer && subjectCustomer.id">
                                <label for="direccion">Dirección</label>
                                <textarea #direccion="ngModel" id="direccion" name="direccion" type="text"
                                          [(ngModel)]="factura.direccion" 
                                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                                          [rows]="2"
                                          [maxlength]="appConfig.app.text.max_length"
                                          placeholder="Dirección del cliente"
                                          [disabled]="false"
                                          [required]='true'
                                          pInputTextarea></textarea>
                                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                                           *ngIf="facturaEditorForm.controls['direccion'] 
                                           && !facturaEditorForm.controls['direccion'].valid 
                                           && (facturaEditorForm.controls['direccion'].dirty 
                                           || facturaEditorForm.controls['direccion'].touched)">
                                </p-message>
                            </div>
                            <div class="p-field col-12" *ngIf="!factura || (subjectCustomer && subjectCustomer.id)">
                                <label for="destinatarios">Notificar a: </label><span class="required-asterisk mr-2">*</span>
                                <mat-form-field id="destinatarios" class="chip-list" appearance="fill">
                                    <mat-label>(Presione enter, espacio, escape o coma, para separar destinatarios)</mat-label>
                                    <mat-chip-list #chipList aria-label="Selección de destinatarios">
                                        <mat-chip
                                            *ngFor="let destinatario of destinatarios"
                                            (removed)="removerDestinatario(destinatario)">
                                            {{destinatario}}
                                            <button matChipRemove>
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip>
                                        <input
                                            placeholder="Agregar..."
                                            #destinatarioInput
                                            [formControl]="destinatarioCtrl"
                                            [matAutocomplete]="auto"
                                            [matChipInputFor]="chipList"
                                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                            (matChipInputTokenEnd)="agregarDestinatario($event)"
                                            [matChipInputAddOnBlur]="false"
                                            (blur)="agregarDestinatarioBlur($event)">
                                    </mat-chip-list>
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedDestinatario($event)">
                                        <mat-option *ngFor="let destinatario of filtered | async" [value]="destinatario">
                                            {{destinatario}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="p-field col-12 md:col-6 mb-0">
                        <div class="font-bold text-indigo-500 bg-indigo-100 p-2 mx-0 uppercase border-round-top">{{'Datos de la Nota de Crédito'}}</div>
                        <div class="bg-indigo-50 p-2 mx-0 border-round-bottom p-fluid p-formgrid grid" >
                            <div class="field col-12">
                                <label class="text-sm" for="tipoDocumentoModificacionfrm">{{'Tipo de documento de modificación'}}</label> 
                                <p-dropdown
                                    #tipo="ngModel"
                                    id="tipoDocumentoModificacion"
                                    name="tipoDocumentoModificacion"
                                    [options]="tiposComprobantes"
                                    [(ngModel)]="selectedTipoComprobante"
                                    optionLabel="description"
                                    [filter]="true"
                                    filterBy="description"
                                    [showClear]="true">
                                    <ng-template pTemplate="selectedItem">
                                        <div class="country-item country-item-value" *ngIf="selectedTipoComprobante">
                                            <div>{{ selectedTipoComprobante.description ?  selectedTipoComprobante.description : 'Selecione un tipo de comprobante...'}}</div>
                                        </div>
                                    </ng-template>
                                    <ng-template let-tipoDocumento pTemplate="item">
                                        <div class="country-item">
                                            <div>{{ tipoDocumento?.description }}</div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                            <div class="p-field col-12 md:col-6 mb-0">
                                <label class="text-sm" for="numeroDocumentoModificacionfrm">{{'Nº. de documento de modificación'}}</label> 
                                <p-inputMask #numeroDocumentoModificacionfrm="ngModel" id="numeroDocumentoModificacionfrm" name="numeroDocumentoModificacionfrm"
                                             [(ngModel)]="factura.notaCredito.numeroDocumentoModificacion" 
                                             mask="999-999-999999999"
                                             placeholder="Ej.: 001-001-00000001"
                                             required></p-inputMask>
                            </div>
                            <div class="p-field col-12 md:col-6 mb-0">
                                <label class="text-sm" for="fechaDocumentoModificacionfrm">Fecha de emisión documento de modificación</label>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-lock"></i>
                                    <p-calendar 
                                        #fechaCaducidad="ngModel"
                                        id="fechaDocumentoModificacionfrm"
                                        name="fechaDocumentoModificacionfrm"
                                        inputId="fechaDocumentoModificacionfrm" 
                                        [(ngModel)]="factura.notaCredito.fechaEmisionDocumentoModificado"
                                        [required]="true"
                                        [showIcon]="true" inputId="icon"
                                        [maxDate]="fechaActual"
                                        (onSelect)="actualizarImpuestosEnDetalles($event)">
                                    </p-calendar>
                                </span>
                                <p-message
                                    severity="error"
                                    [text]="appConfig['validationMsgs']['dateInvalid']"
                                    *ngIf="
                                    facturaEditorForm.controls['fechaDocumentoModificacionfrm'] &&
                                    !facturaEditorForm.controls['fechaDocumentoModificacionfrm'].valid &&
                                    (facturaEditorForm.controls['fechaDocumentoModificacionfrm'].dirty ||
                                    facturaEditorForm.controls['fechaDocumentoModificacionfrm'].touched)
                                    ">
                                </p-message>
                            </div>
                            <div class="field col-12">
                                <label class="text-sm" for="motivoModificacionfrm">{{'Motivo de modificación'}}</label> 
                                <input #motivoModificacionfrm="ngModel" id="motivoModificacionfrm" name="motivoModificacionfrm"
                                       type="text"
                                       [(ngModel)]="factura.notaCredito.motivoModificacion"
                                       [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                                       [disabled]="factura && factura.secuencial"
                                       pInputText
                                       required/>
                            </div>
                        </div>
                    </div>
                    <div class="p-field col-12"
                         *ngIf="isUnitDetail">
                        <p-button styleClass="p-button-outlined p-button-plain"
                                  (click)="activePopupProducts($event)"
                                  [disabled]="factura && factura.secuencial">
                            <ng-template pTemplate="content">
                                <div class="p-field col-12 mb-0">
                                    <div class="flex align-items-center justify-content-between">
                                        {{(product && product.id) ? product.name : 'Servicio/Producto...'}}
                                        <i class="pi pi-plus required-icon"></i>
                                    </div>
                                </div>  
                            </ng-template>
                        </p-button>
                    </div>
                    <div class="p-field col-12"
                         *ngIf="isUnitDetail">
                        <p-inputNumber #subtotal="ngModel" id="subtotal" name="subtotal"
                                       [(ngModel)]="factura.subTotal" 
                                       (onBlur)="calcularConSubtotalPersonalizado($event)"
                                       placeholder="0.00"
                                       mode="currency" currency="USD" locale="en-US"
                                       [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2"
                                       prefix="la cantidad de "
                                       [disabled]="factura && factura.secuencial"
                                       required>
                        </p-inputNumber>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['numberPattern']" 
                                   *ngIf="facturaEditorForm.controls['subtotal']
                                   && !facturaEditorForm.controls['subtotal'].valid 
                                   && (facturaEditorForm.controls['subtotal'].dirty 
                                   || facturaEditorForm.controls['subtotal'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12" 
                         *ngIf="isUnitDetail && details.length > 0">
                        <textarea #description="ngModel" id="description" name="description" type="text"
                                  [(ngModel)]="factura.description" 
                                  [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                                  [rows]="3"
                                  placeholder="Detallar..."
                                  [disabled]="factura && factura.secuencial"
                                  pInputTextarea></textarea>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                                   *ngIf="facturaEditorForm.controls['description'] 
                                   && !facturaEditorForm.controls['description'].valid 
                                   && (facturaEditorForm.controls['description'].dirty 
                                   || facturaEditorForm.controls['description'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12 mb-0">
                        <p-button *ngIf="!isUnitDetail"
                                  styleClass="p-button-outlined p-button-plain"
                                  (click)="activePopupProducts($event)"
                                  [disabled]="factura && factura.secuencial">
                            <ng-template pTemplate="content">
                                <div class="p-field col-12 mb-0">
                                    <div class="flex align-items-center justify-content-between">
                                        {{(product && product.id) ? product.name : 'Servicio/Producto...'}}
                                        <i class="pi pi-plus required-icon"></i>
                                    </div>
                                </div>  
                            </ng-template>
                        </p-button>
                        <div id="invoice-content">
                            <div class="invoice p-0">
                                <div *ngIf="!isUnitDetail" 
                                     class="invoice-items p-0 m-1">
                                    <p-table [value]="details">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th> {{'Descripción'}} </th>
                                                <th> {{'Cantidad'}} </th>
                                                <th> {{'Precio Unitario'}} </th>
                                                <th> {{'Valor Total'}} </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rowData>
                                            <tr>    
                                                <td>{{rowData['product']['name']}} <p-badge [value]="'IVA ' + rowData['product']['taxFactor']"></p-badge></td>
                                            <td>{{rowData['amount'] ? rowData['amount'] : 0.00}}</td>
                                            <td>$ {{rowData['product']['price'] ? rowData['product']['price'] : 0.00}}</td>
                                            <td>$ {{(rowData['product']['price'] && rowData['amount']) ? (rowData['product']['price'] * rowData['amount']).toFixed(2) : 0.00}}</td>
                                        </ng-template>
                                    </p-table>
                                </div>
                                <div class="invoice-summary p-0">
                                    <div class="invoice-notes">
                                        <div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="invoice-details">
                                            <div class="invoice-label">Sub. IVA 0%</div>
                                            <div class="invoice-value">$ {{ factura.subTotalIva0 ? factura.subTotalIva0.toFixed(2) : '0.00' }}</div>
                                            <div class="invoice-label">Sub. IVA {{ this.iva.etiqueta }}</div>
                                            <div class="invoice-value">$ {{ factura.subTotalIva12 ? factura.subTotalIva12.toFixed(2) : '0.00' }}</div>
                                            <div class="invoice-label">SUBTOTAL</div>
                                            <div class="invoice-value">$ {{ factura.subTotal ? factura.subTotal.toFixed(2) : '0.00' }}</div>
                                            <div class="invoice-label">IVA {{ this.iva.etiqueta }}</div>
                                            <div class="invoice-value">$ {{ factura.iva12Total ? factura.iva12Total.toFixed(2) : '0.00' }}</div>
                                            <div class="invoice-label">VALOR TOTAL</div>
                                            <div class="invoice-value">$ {{ factura.importeTotal ? factura.importeTotal.toFixed(2) : '0.00' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p-footer>
                    <div class="flex align-items-center justify-content-end">
                        <button pButton pRipple
                                type="button" 
                                label="{{appConfig.ux.actions.cancel}}"
                                icon="pi pi-times" class="p-button-secondary"
                                (click)="fazilService.irAInicioNotasdeCredito()">
                        </button>
                        <button  pButton pRipple
                                 type="submit" 
                                 label="{{ appConfig.ux.actions.emitir }}"
                                 icon="pi pi-send" class="ml-1"
                                 [disabled]="(!facturaEditorForm.valid
                                 || !exitenProductosSeleccionados 
                                 || (!subjectCustomer || !subjectCustomer.customerId)
                                 || (!factura.importeTotal || factura.importeTotal <= 0)
                                 || !camposAdicionalesValidos()
                                 || !destinatarios)">
                        </button>
                    </div>
                </p-footer>
            </form>
        </div>
    </div>
</div>
<p-messages [(value)]="msgs"></p-messages>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!---Diálogo de selección de Contactos/Clientes--->
<p-dialog [(visible)]="mostrarPopupSubjectCustomers" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="mostrarPopupSubjectCustomers=false;"    
          [closable]="true"
          styleClass="p-dialog-product">
    <ng-template pTemplate="header">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center flex-auto">
            <div class="mb-3 font-bold text-2xl">
                <span class="text-900">Tus Contactos/Clientes, </span>
                <span class="text-blue-600">listos para que factures..</span>
            </div>
            <div class="text-700 text-sm mb-2">Busca a tus Contactos/Clientes <strong>{{currentUser.initials}}</strong>.</div>
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left w-full">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="filteredSubjectCustomerByKeyword($event)"
                        placeholder="{{appConfig.ux.searchMsg}}"
                        class="w-full"/>
                </span>
                <button pButton pRipple
                        type="button" 
                        pTooltip="{{ appConfig.ux.actions.add }}" tooltipPosition="bottom"
                        icon="pi pi-plus" class="p-button-rounded p-button-secondary p-button-sm ml-1"
                        (click)="nuevoContacto()">
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center">
            <div class="grid">
                <div *ngFor="let item of subjectCustomersFiltered" 
                     class="col-12 md:col-4 mb-1 p-1">
                    <p-button [styleClass]="(subjectCustomer && subjectCustomer.customerFullName && subjectCustomer.customerFullName == item.customerFullName) ? 'bg-bluegray-100 shadow-1 p-3 h-full w-full' : 'p-button-text shadow-1 p-3 h-full w-full'"
                              (click)="cargarDataSubjectCustomer($event, item)"
                              (dblClick)="cargarDataSubjectCustomer($event, item)">
                        <ng-template pTemplate="content">
                            <div class="flex-auto  w-full">
                                <img [src]="item.customerImage" class="h-2rem"/>
                                <div class="text-900 mt-1 mb-3 font-medium">{{item.customerCode}}</div>
                                <div class="text-700 mb-3 text-sm line-height-3 uppercase">{{item.customerFullName}}</div>
                                <div class="text-700 mb-3 text-sm line-height-3 text-blue-600">{{item.customerEmail}}</div>
                            </div>
                        </ng-template>
                    </p-button>
                </div>
                <div *ngIf="(!subjectCustomersFiltered || !subjectCustomersFiltered.length)"
                     class="col-12 md:col-12 mb-1 p-6">
                    <i *ngIf="!processFilter" class="pi pi-users text-8xl"></i>
                    <br>
                    <strong *ngIf="!processFilter && (subjectCustomers && subjectCustomers.length)">{{appConfig.ux.emptyMsg}}</strong>
                    <i *ngIf="processFilter" class="pi pi-spin pi-spinner text-8xl"></i>
                </div>  
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>
<!-- Editor de contacto -->
<app-contacto [mostrarEditor] = "mostrarEditorSubject" 
              [subjectCustomer] ="subjectCustomer"
              [estaCargandoDatos] = "false"
              (contactoGuardado) = "handleSubjectCustomerSaved($event);"></app-contacto>

<!---Diálogo de selección de productos--->
<p-dialog [(visible)]="mostrarPopupProducts" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="mostrarPopupProducts=false;"    
          [closable]="true"
          styleClass="p-dialog-product">
    <ng-template pTemplate="header">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center flex-auto">
            <div class="mb-3 font-bold text-2xl">
                <span class="text-900">¡Atención!, </span>
                <span class="text-blue-600">verifique el precio e impuesto que aplica</span>
            </div>
            <div class="text-700 text-sm mb-2">Productos y Servicios que ofrece <strong>{{currentUser.initials}}</strong>.</div>
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left w-full">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="filteredProductByKeyword($event)"
                        placeholder="{{appConfig.ux.searchMsg}}"
                        class="w-full"/>
                </span>
                <button pButton pRipple
                        type="button" 
                        pTooltip="{{ appConfig.ux.actions.add }}" tooltipPosition="bottom"
                        icon="pi pi-plus" class="p-button-rounded p-button-secondary p-button-sm ml-1"
                        (click)="nuevoServicio()">
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center">
            <div class="grid">
                <div *ngFor="let item of productsFiltered" 
                     class="col-12 md:col-3 p-1 h-full">
                    <div class="col-12">
                        <button *ngIf="item.amount && item.amount > 0"
                                pButton pRipple
                                type="button" 
                                pTooltip="{{ 'Quitar' }}" tooltipPosition="bottom"
                                icon="pi pi-times" class="p-button-rounded p-button-plain p-button-sm" style="float: right;"
                                (click)="quitarProductoSeleccionadoDeProductos($event, item)">
                        </button>
                    </div>
                    <div [class]="item.amount && item.amount > 0 ? 'col-12 bg-bluegray-100' : ''">
                        <div class="mb-5"></div>
                        <div class="mb-3 text-700 text-sm line-height-3 uppercase">{{item.productType == 'SERVICE' ? 'Servicio' : 'Producto'}}</div>
                        <p-button [styleClass]="(item.amount && item.amount > 0) ? 'p-button-primary shadow-1 p-3' : 'p-button-text shadow-1 p-3'"
                                  (click)="cargarDataProduct($event, item)"
                                  (dblClick)="cargarDataProduct($event, item)">
                            <ng-template pTemplate="content">
                                <div class="flex-auto w-full">
                                    <img [src]="!item.photo ? '/assets/layout/icons/product.png' : item.photo" class="h-2rem"/>
                                </div>
                            </ng-template>
                        </p-button>
                        <div class="text-900 mt-1 mb-3 font-medium text-blue-600">${{item.price ? item.price.toFixed(2): appConfig.ux.undefinedNumber}} <p-badge [value]="'IVA ' + item.taxFactor"></p-badge></div>
                        <div class="text-700 text-sm line-height-3 uppercase">{{item.name ? item.name :  appConfig.ux.undefinedString}}</div>
                        <p-inputNumber *ngIf="item.amount && item.amount > 0"
                                       #productAmount="ngModel" id="productAmount" name="productAmount" 
                                       [(ngModel)]="item.amount" 
                                       (onBlur)="cargarDataProduct($event, item)"
                                       placeholder="{{appConfig.ux.undefinedNumber}}"
                                       mode="decimal" locale="en-US"
                                       [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2"
                                       prefix="Por facturar "
                                       required>
                        </p-inputNumber>
                    </div>
                </div>
                <div *ngIf="(!productsFiltered || !productsFiltered.length)"
                     class="col-12 md:col-12 mb-1 p-6">
                    <i *ngIf="!processFilter" class="pi pi-shopping-bag text-8xl"></i>
                    <br>
                    <strong *ngIf="!processFilter && (products && products.length)">{{appConfig.ux.emptyMsg}}</strong>
                    <i *ngIf="processFilter" class="pi pi-spin pi-spinner text-8xl"></i>
                </div>  
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>
<!--Diálogos de creación/edición de product--> 
<p-dialog
    [header]="product && product.id ? appConfig.ux.actions.edit : appConfig.ux.actions.create +' Servicio/Producto'"
    [(visible)]="mostrarEditorProduct"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '75vw', '640px': '85vw' }"
    [style]="{ width: '75vw' }"
    (onHide)="mostrarEditorProduct = false">
    <form
        #productEditorForm="ngForm"
        (ngSubmit)="guardarServicio()"
        [ngClass]="{ disabledForm: false }">
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid grid">
            <div class="p-field col-12">
                <h2 class="uppercase">{{ product.name }}</h2>
            </div>
            <div class="p-field col-12 md:col-6">
                <label for="namefrm">Nombre</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-bookmark"></i>
                    <input
                        #namefrm="ngModel" id="namefrm" name="namefrm"
                        type="text"
                        [(ngModel)]="product.name"
                        (keyup)="ui.onKey($event)"
                        [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                        [disabled]="false" 
                        required
                        pInputText/>
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern']"
                    *ngIf="productEditorForm.controls['namefrm'] &&
                    !productEditorForm.controls['namefrm'].valid &&
                    (productEditorForm.controls['namefrm'].dirty ||
                    productEditorForm.controls['namefrm'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 md:col-6">
                <label for="pricefrm">Precio</label>
                <p-inputNumber 
                    #pricefrm="ngModel" inputId="pricefrm" name="pricefrm" 
                    mode="currency" currency="USD" 
                    [(ngModel)]="product.price"
                    placeholder="{{appConfig.ux.undefinedNumber}}"
                    (keyup)="ui.onKey($event)"
                    [showButtons]="true" [min]="0"
                    [pattern]="appConfig['validationRegExp']['numberPattern']"
                    [disabled]="false" 
                    required>
                </p-inputNumber>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['numberPattern']"
                    *ngIf="productEditorForm.controls['pricefrm'] &&
                    !productEditorForm.controls['pricefrm'].valid &&
                    (productEditorForm.controls['pricefrm'].dirty ||
                    productEditorForm.controls['pricefrm'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 md:col-6">
                <p-selectButton 
                    #productTypefrm="ngModel" id="productTypefrm" name="productTypefrm" 
                    [options]="productTypes" 
                    [(ngModel)]="productType" 
                    optionLabel="name" optionValue="value"
                    required>
                </p-selectButton>
            </div>
            <div class="p-field col-12 md:col-6 align-self-center">
                <label for="iva12frm">IVA {{ appConfig.app.iva.etiqueta }}</label>
                <p-inputSwitch 
                    #iva12frm="ngModel" inputId="iva12frm" name="iva12frm" 
                    [(ngModel)]="iva12"
                    class="ml-2">
                </p-inputSwitch>
            </div>
        </div>
        <p-footer>
            <div class="flex align-items-center justify-content-end">
                <button
                    pButton pRipple
                    type="button"
                    label="{{ appConfig.ux.actions.cancel }}"
                    icon="pi pi-times" class="p-button-secondary"
                    (click)="mostrarEditorProduct = false">
                </button>
                <button
                    pButton pRipple
                    type="submit"
                    label="{{ appConfig.ux.actions.save }}"
                    icon="pi pi-check" class="ml-1"
                    [disabled]="(!productEditorForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd 
                 header="{{appConfig.ux.confirmMsg}}" 
                 icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmFalse}}"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmTrue}}"
                icon="pi pi-check" class="ml-1"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog [(visible)]="procesando" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="procesando=false;">
    <ng-template pTemplate="header">
        <h4>{{appConfig.ux.loadingMsg}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar> 
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="uppercase">{{appConfig.app.name}}</span>
    </ng-template>
</p-dialog>
<!--Ventana de resultData-->
<p-dialog [(visible)]="mostrarResultData" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '25vw', '640px': '35vw' }" 
          [style]="{ width: '25vw' }"
          (onHide)="mostrarResultData=false;">
    <ng-template pTemplate="header">
        <h4>{{resultData['header']}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages severity="{{resultData['type']}}">
            <ng-template pTemplate>
                <div class="ml-2">{{resultData['body']}}</div>
            </ng-template>
        </p-messages>

        <p-panel header="Detalle de errores" [toggleable]="true" [collapsed]="true" *ngIf="resultData['subErrors'] && resultData['subErrors'].length > 0">
            <p-messages severity="info" *ngFor="let subError of resultData['subErrors']">
                <ng-template pTemplate>
                    <div class="ml-2">{{subError.field}} | {{subError.rejectedValue}} | {{subError.message}}</div>
                </ng-template>
            </p-messages>
        </p-panel>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex align-items-center justify-content-center">
            <button *ngFor="let item of resultDataButtons let i = index" 
                    pButton pRipple
                    type="button" 
                    [label]="item.text"
                    [icon]="item.icon"
                    [class]="item.cssClass"
                    (click)="ejecutarAccionResult($event, item.action, null)"
                    [disabled]="item.disabled">
            </button>
        </div>
    </ng-template>
</p-dialog>
<!--Ventana de espera de verificacion-->
<p-dialog [(visible)]="verificando"
          modal="modal" showEffect="fade"
          [breakpoints]="{ '960px': '15vw', '640px': '20vw' }" 
          [style]="{ width: '15vw' }"
          [closable]="false"
          (onHide)="verificando = false"
          class="text-center">
    <ng-template pTemplate="header">
    </ng-template>
    <ng-template pTemplate="content">
        <h6>{{verificandoData['body']}}</h6>
        <i class="pi pi-spin pi-spinner text-orange-400 text-8xl"></i>
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{ appConfig.app.name }}</span>
    </ng-template>
</p-dialog>